/**
 * CDN loader: fetch version.json next to this script, then inject the proxy bundle
 * with ?v=<version> so updates bypass browser cache without editing storefront HTML.
 *
 * Deploy /cdn/gtm-datalayer-loader.iife.js + /cdn/version.json + /cdn/gtm-datalayer-proxy.iife.js
 */
(function loader(): void {
  if (typeof document === 'undefined') return;

  const currentScript = document.currentScript as HTMLScriptElement | null;
  if (!currentScript?.src) return;

  let baseUrl: URL;
  try {
    baseUrl = new URL(currentScript.src);
  } catch {
    return;
  }

  const dir = baseUrl.pathname.replace(/[^/]+$/, '');
  const originBase = `${baseUrl.origin}${dir}`;

  const manifestUrl = `${originBase}version.json?_=${Date.now()}`;

  fetch(manifestUrl, { cache: 'no-store', credentials: 'omit' })
    .then((res) => {
      if (!res.ok) throw new Error(`version.json ${res.status}`);
      return res.json() as Promise<{ version?: string; filename?: string }>;
    })
    .then((manifest) => {
      const version = manifest.version ?? '';
      const filename = manifest.filename ?? 'gtm-datalayer-proxy.iife.js';
      if (!version) throw new Error('version.json missing version');

      const proxySrc = `${originBase}${filename}?v=${encodeURIComponent(version)}`;
      const el = document.createElement('script');
      el.src = proxySrc;
      el.async = true;
      const parent = currentScript.parentNode ?? document.head;
      parent.insertBefore(el, currentScript.nextSibling);
    })
    .catch((err: unknown) => {
      try {
        console.error('[gtm-datalayer-loader]', err);
      } catch {}
    });
})();
